export default {
  name: 'IQToolMiddlePaneHeader',
  props: {
    header: {
      type: String,
      default: 'Header',
    },
    title: {
      type: String,
    },
    additionalLabels: {
      type: Array,
      default: () => [],
    },
    showCopy: {
      type: Boolean,
      default: false,
    },
    showView: {
      type: Boolean,
      default: false,
    },
    showEdit: {
      type: Boolean,
      default: false,
    },
    goToListPage: {
      type: Function,
      default: () => {},
    },
  },
  emits: ['save', 'copy', 'view', 'edit', 'goToListPage', 'selectLabel'],
  mounted() {
  },
  methods: {
    onCopy() {
      this.$emit('copy');
    },
    onAdditionalLabelClick(label) {
      this.$emit('selectLabel', label);

    },
    getClass(label) {
      if (label.selected) {
        return 'selected';
      }
      if (!label.active) {
        return 'inactive';
      }
      return '';
    },
    onView() {
      this.$emit('view');
    },
    onEdit() {
      this.$emit('edit');
    },
    onGoToListPage() {
      this.$emit('goToListPage');
    },
  },
};
